import { Observable } from 'rxjs';

export abstract class BaseTranslationService {
    abstract init(): void;

    abstract controlLanguageUser(languageUser: string): void;

    abstract getLocaleByName(langName: string): string | null;

    /**
     * Checks if the passed language code exists in our app
     * @param shortCode two digit language code
     */
    abstract existLocaleByCode(shortCode: string): boolean;

    /**
     * Gets the equivalent twc language code from the passed one
     * @param shortCode two digit language code to compare with the language list (only the language, not the region in the code)
     */
    abstract getTwcLocale(shortCode: string): string;

    /**
     * Gets the equivalent pcviz language code from the passed one
     * @param shortCode two digit language code to compare with the language list
     */
    abstract getPcvizLocale(shortCode: string): string;

    abstract get currentLang(): string;

    abstract changeLanguage(pcvizCode: string): void;

    abstract translate(key: string, params?: any): string;

    abstract translateAsync(key: string, params?: any): Observable<string>;

    abstract existKey(key: string): boolean;

    abstract translateWithDefault(key: string | undefined, defaultKey: string | undefined, params?: any): string;
}
